import Skeleton from "react-loading-skeleton"

const FiltersSkt = () => {
    return (
        <div className="d-flex align-items-center gap-3">
            <div className="tw-py-5 tw-w-20"><Skeleton style={{ height: '50px' }} /></div>
            <div className="tw-py-5 tw-w-20"><Skeleton style={{ height: '50px' }} /></div>
            <div className="tw-py-5 tw-w-20"><Skeleton style={{ height: '50px' }} /></div>
        </div>
    )
}

export default FiltersSkt